// Loading Component to show while the API is fetching
import React from 'react';
import instalily_mark_white_4x from "../assets/instalily_mark_white_4x.png"
import logo_animation_black from "../assets/logo-animation-black.gif"
import logo_animation_white from "../assets/logo-animation-white.gif"

function Loading() {
	return (
		<div className="flex flex-col items-center h-screen">
			<div className='flex flex-row items-center mt-10'>
				<p className='font-extrabold text-3xl text-neutral-950'>
					Loading...
				</p>
				{/* <img src={instalily_mark_white_4x} alt="" className='invert size-10 ml-5 spin'></img> */}
				<img src={logo_animation_black} alt="" className="size-16 ml-0 dark:hidden" />
				<img src={logo_animation_white} alt="" className="size-16 ml-0 hidden dark:block" />
			</div>
		</div>
	);
};

export default Loading;